import { render, staticRenderFns } from "./content_main_list.vue?vue&type=template&id=437bf874&"
import script from "./content_main_list.vue?vue&type=script&lang=js&"
export * from "./content_main_list.vue?vue&type=script&lang=js&"
import style0 from "./content_main_list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports